import React from 'react';
import { text } from 'components/common/Text';

export default function About() {
  return (
    <>
      <div className="color-dark-grey font-btn" style={{ lineHeight: '1.6' }}>
        <p className="my-3">{text('about.app_supports')}</p>
        <p className="my-3">{text('about.app_exp')}</p>
        <p>{text('about.app_brief')}</p>
        <ul className="ml-4">
          <li>
            <span className="font-bold">{text('about.credentialing')}</span>
            <span>{text('about.credentialig_text')}</span>
          </li>
          <li>
            <span className="font-bold">{text('about.institution')}</span>
            <span>{text('about.institution_text')}</span>
          </li>
          <li>
            <span className="font-bold">{text('about.person')}</span>
            <span>{text('about.person_text')}</span>
          </li>
          <li>
            <span className="font-bold">{text('about.admin')}</span>
            <span>{text('about.admin_text')}</span>
          </li>
        </ul>
      </div>
    </>
  );
}
